import { gql } from "@apollo/client";

export const MOMENT_REQUEST_CLIP = gql`
  mutation Mutation($momentRequestClipInput: MomentRequestClipInput!) {
    momentRequestClip(momentRequestClipInput: $momentRequestClipInput) {
      success
      errors {
        message
        field
        code
      }
    }
  }
`;

export const MOMENT_CREATE_CLIP = gql`
  mutation MomentCreateClip($momentCreateClipInput: MomentCreateClipInput!) {
    momentCreateClip(MomentCreateClipInput: $momentCreateClipInput) {
      errors {
        field
        code
        message
      }
      moments {
        id
      }
      success
    }
  }
`;

export const GET_MOMENT = gql`
  query Moment($id: String!) {
    moment(id: $id) {
      id
      title
      game
      match {
        id
      }
    }
  }
`;
